import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Text from '../text';
import ButtonGroup from '../button-group';
import Button from '../button';
import Modal from '../modal';
import Loader from '../loader';
import Render from '../render';
import noop from '../utils/noop';

const WIDTH = 376;
const MIN_WIDTH = 312;
const HEIGHT = 196;

const defaultAttributes = {};

function ProgressDialog({
  width = WIDTH,
  height = HEIGHT,
  minWidth = MIN_WIDTH,
  minHeight = HEIGHT,
  offsetX = 0,
  offsetY = 0,
  value = 0,
  captions: { title, description, cancel },
  onCancel = noop,
  overlay = 'transparent',
  cancelable = true,
  showProgress = true,
  progressType = 'determinate',
  attributes = defaultAttributes,
  className = '',
  containerClassName = '',
}) {
  const modalClassNames = classNames('ws-progress-dialog', className);
  return (
    <Modal
      overlay={overlay}
      centered
      resizable={false}
      draggable={false}
      className={modalClassNames}
      width={width}
      height={height}
      minWidth={minWidth}
      minHeight={minHeight}
      offsetX={offsetX}
      offsetY={offsetY}
      containerClassName={containerClassName}
      attributes={attributes}
      {...(cancelable && { handleCancel: onCancel })}
    >
      <div className="ws-progress-dialog__inner">
        <Render if={showProgress}>
          <Loader value={value} type={progressType} />
        </Render>
        <div className="ws-progress-dialog__content">
          <Text type="heading-5" className="ws-progress-dialog__title">
            {title}
          </Text>
          <Render if={Boolean(description)}>
            <Text theme="grey" align="center" className="ws-progress-dialog__description">
              {description}
            </Text>
          </Render>
        </div>

        {cancelable && (
          <ButtonGroup className="ws-progress-dialog__buttons">
            <Button stretch="block" size="large" onClick={onCancel}>
              {cancel}
            </Button>
          </ButtonGroup>
        )}
      </div>
    </Modal>
  );
}

ProgressDialog.propTypes = {
  minWidth: PropTypes.number,
  minHeight: PropTypes.number,
  width: PropTypes.number,
  height: PropTypes.number,
  offsetX: PropTypes.number,
  offsetY: PropTypes.number,
  captions: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    cancel: PropTypes.string,
  }).isRequired,
  attributes: PropTypes.shape(),
  className: PropTypes.string,
  containerClassName: PropTypes.string,
  onCancel: PropTypes.func,
  value: PropTypes.number,
  overlay: PropTypes.oneOf(['transparent', 'visible', 'none']),
  cancelable: PropTypes.bool,
  showProgress: PropTypes.bool,
  progressType: PropTypes.oneOf(['determinate', 'indeterminate']),
};

export default ProgressDialog;
